import { Controller } from 'stimulus'

// Controls searchable select dropdowns for nationality and other fields
export default class extends Controller {
  static targets = ['input', 'dropdown', 'option']

  connect() {
    this.setupSearchableSelect()
  }

  setupSearchableSelect() {
    const select = this.element
    const wrapper = document.createElement('div')
    wrapper.className = 'searchable-select-wrapper'
    
    // Create search input
    const searchInput = document.createElement('input')
    searchInput.type = 'text'
    searchInput.className = 'searchable-select-input'
    searchInput.placeholder = 'Search...'
    searchInput.addEventListener('input', (e) => this.filterOptions(e.target.value))
    
    // Create dropdown
    const dropdown = document.createElement('div')
    dropdown.className = 'searchable-select-dropdown'
    dropdown.style.display = 'none'
    
    // Populate dropdown with options
    const options = Array.from(select.options)
    options.forEach(option => {
      if (option.value) {
        const optionElement = document.createElement('div')
        optionElement.className = 'searchable-select-option'
        optionElement.textContent = option.textContent
        optionElement.dataset.value = option.value
        optionElement.addEventListener('click', () => this.selectOption(option.value, option.textContent))
        dropdown.appendChild(optionElement)
      }
    })
    
    // Replace select with new structure
    select.style.display = 'none'
    wrapper.appendChild(searchInput)
    wrapper.appendChild(dropdown)
    select.parentNode.insertBefore(wrapper, select)
    
    // Store references
    this.searchInput = searchInput
    this.dropdown = dropdown
    this.select = select
    this.options = options
    
    // Handle focus/blur
    searchInput.addEventListener('focus', () => this.showDropdown())
    searchInput.addEventListener('blur', () => {
      setTimeout(() => this.hideDropdown(), 200)
    })
  }

  filterOptions(searchTerm) {
    const options = this.dropdown.querySelectorAll('.searchable-select-option')
    const term = searchTerm.toLowerCase()
    
    options.forEach(option => {
      const text = option.textContent.toLowerCase()
      if (text.includes(term)) {
        option.style.display = 'block'
      } else {
        option.style.display = 'none'
      }
    })
  }

  selectOption(value, text) {
    this.select.value = value
    this.searchInput.value = text
    this.hideDropdown()
    
    // Trigger change event on original select
    const event = new Event('change', { bubbles: true })
    this.select.dispatchEvent(event)
  }

  showDropdown() {
    this.dropdown.style.display = 'block'
  }

  hideDropdown() {
    this.dropdown.style.display = 'none'
  }
} 